import { render, staticRenderFns } from "./VideoLists.vue?vue&type=template&id=f0555ec8&scoped=true&"
import script from "./VideoLists.vue?vue&type=script&lang=js&"
export * from "./VideoLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0555ec8",
  null
  
)

export default component.exports